module.exports = __webpack_public_path__ + "static/img/projectDetail_3.c27543f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mainPage/projectDetail_3.jpg
// module id = z3Rs
// module chunks = 0